import React from 'react';
import { connect } from 'react-redux';
import i18n from 'I18n';
import BaseLeftSection from './BaseLeftSection';

const GreetingComponent = ({
  language,
  isLogin,
  displayName,
}) => {
  if (!isLogin) {
    return null;
  };

  return (
    <BaseLeftSection 
      title={i18n.t('home_hello') + '!'}
      content={displayName}
    />
  );
};


const mapStateToProps = (state) => ({
  language: state.users.language,
  isLogin: state.users.isLogin,
  displayName: state.users.displayName,
})


export default connect(mapStateToProps)(GreetingComponent);
